import { UPDATE_PERSONAL_INFO_FLAG, UPDATE_EXAM_DETAILS_FLAG, 
    UPDATE_INSTITUTION_DETAILS_FLAG, UPDATE_EXAM_INSTITUTION_REVIEW_FLAG,
    UPDATE_INSTITUTION_REVIEW_FLAG, UPDATE_REVIEW_FLAG, UPDATE_REVIEW_DETAILS_FLAG,
    UPDATE_PAY_FLAG,UPDATE_TRANSACTION_HISTORY_FLAG,HISTORY_PAY_NAV_FLAG,
    RESET_STATE_TRANSITION_FLAGS,UPDATE_ADYEN_FLAG} from "../actionTypes";

const initialState = {
  isTranscriptHistoryCrossed: false,
  isPersonalInfoCrossed: false,
  isExamDetailsCrossed: false,
  isInstitutionDetailsCrossed: false,
  isReviewAndConfirmCrossed: false,
  isTermsCrossed: false,
  isAdyen:false,
  isHistoryPayNav:false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TRANSACTION_HISTORY_FLAG: {
      return{
        ...state,
        isTranscriptHistoryCrossed: true
      };
    }
    case UPDATE_PERSONAL_INFO_FLAG: {
      return {
        ...state,
        isPersonalInfoCrossed: true
      };
    }
    case UPDATE_EXAM_DETAILS_FLAG: {
        return {
          ...state,
          isExamDetailsCrossed: true
        };
      }
      case UPDATE_INSTITUTION_DETAILS_FLAG: {
        return {
          ...state,
          isInstitutionDetailsCrossed: true
        };
      }
      case UPDATE_REVIEW_DETAILS_FLAG: {
        return {
          ...state,
          isPersonalInfoCrossed: false,
          isExamDetailsCrossed: false,
          isInstitutionDetailsCrossed: false,
          isReviewAndConfirmCrossed: true
        };
      }
      case UPDATE_EXAM_INSTITUTION_REVIEW_FLAG: {
        return {
          ...state,
          isExamDetailsCrossed: false,
          isInstitutionDetailsCrossed: false,
          isReviewAndConfirmCrossed: false
        };
      } 
      case UPDATE_INSTITUTION_REVIEW_FLAG: {
        return {
          ...state,
          isInstitutionDetailsCrossed: false,
          isReviewAndConfirmCrossed: false
        };
      } 
      case UPDATE_REVIEW_FLAG: {
        return {
          ...state,
          isReviewAndConfirmCrossed: false
        };
      }
      case UPDATE_PAY_FLAG:{
        return {
          ...state,
          isReviewAndConfirmCrossed: true
        }
      }
      case UPDATE_ADYEN_FLAG:{
        return{
          ...state,
          isTermsCrossed:true
        }
      }
      case HISTORY_PAY_NAV_FLAG:{
        return{
          ...state,
          isHistoryPayNav: true
        }
      }
      case RESET_STATE_TRANSITION_FLAGS:{
        return {...initialState};
      } 
    default:
      return state;
  }
}